export const DataCaptureRoutes = {
  DataCaptureRequests: '/dataCapture/requests',
};
